import axios from "axios";
import { toast } from "react-toastify";

const instance = axios.create({
  // baseURL: "http://localhost:3000/api",
  baseURL: "https://sales-api.buildhub.ph/api",
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("err", error.response);
    if (error.response.data && error.response.data.message === "jwt expired") {
      toast.error("Your session has expired. Please log in again.");
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default instance;
